<template>
  <div>
    <img @click="$refs.fileInput.click()" src="@/assets/icons/image.svg" width="25" height="25" class="cursor-pointer" />
    <input type="file" ref="fileInput" @change="handleFileUpload" style="display: none" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { UPLOAD_FILE } from "@/store/actions";

import { ACCEPTED_TYPES } from "@/constants/storage";

export default {
  name: "ReplyFile",
  methods: {
    ...mapActions("files", { uploadFile: UPLOAD_FILE }),
    async handleFileUpload(event) {
      const [file] = event.target.files;

      if (!file) return;
      const { type: fileType, size: fileSize, name: fileName } = file;

      if (fileSize > 10 * 1024 * 1024) {
        alert("File size exceeds 10MB. Please upload a smaller file.");
        return;
      }

      if (!ACCEPTED_TYPES.includes(fileType)) {
        ("Invalid file type. Please upload an image.");
        return;
      }
      const ext = fileName.split(".").pop();
      const { key, url } = await this.uploadFile({ file, ext });

      console.log("URL", url);

      this.$emit("image", { imageId: key, url, ext });
    },
  },
};
</script>
